import { jsx } from 'react/jsx-runtime';
import { useThemeContext } from '../../../context/ThemeContext/ThemeContext.js';
import { Switch } from '../../Switch/Switch.js';

const BrandStyleSwitch = () => {
    const { changeBrandStyle, theme } = useThemeContext();
    return (jsx(Switch, { firstButton: {
            active: theme.brandStyle === 'bold',
            handleButtonClick: () => changeBrandStyle('bold'),
            name: 'Bold',
        }, secondButton: {
            active: theme.brandStyle === 'subtle',
            handleButtonClick: () => changeBrandStyle('subtle'),
            name: 'Subtle',
        } }));
};

export { BrandStyleSwitch };
